/* ==========================================================================
   C2V Studio (1/2) : moteur de rendu et gabarit
   - reglages (palettes, zone logo 639 x 429, geometrie des visuels)
   - rendu 3D + vue de dessus recolores en direct (canvas)
   - logo converti en aplat 1 couleur, visuel d'emballage via pdf.js
   - gabarit HTML de la pop-up
   - textes traduits (T, TP), nombres et prix selon la langue de la page
   L'interface (etapes, prix, synchro jauge, panier, sauvegarde) est dans c2v-studio.js.
   ========================================================================== */
(() => {
  'use strict';
  if (window.C2VLib) return;

  /* ------------------------------------------------------------------ Langue */
  // Textes : window.C2V_I18N (snippet c2v-i18n.liquid, cles c2v.* des fichiers de langue du theme),
  // sinon le francais passe en argument. Variables {nom}. Langue de la page : window.C2V_LOCALE.
  const LOCALE = String(window.C2V_LOCALE || 'fr');
  const FR = LOCALE.split('-')[0].toLowerCase() === 'fr';
  const INTL = FR ? 'fr-FR' : LOCALE.toLowerCase() === 'en' ? 'en-GB' : LOCALE;
  const MISSING = /^translation missing/i;
  // le filtre t de Shopify echappe le HTML des cles sans _html : on remet les caracteres d'origine
  const unescHtml = s => s.replace(/&(amp|lt|gt|quot|#39|#x27|#039);/g, (m, e) => ({ amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'", '#x27': "'", '#039': "'" }[e]));
  const fill = (s, vars) => (vars ? s.replace(/\{(\w+)\}/g, (m, n) => (Object.prototype.hasOwnProperty.call(vars, n) ? String(vars[n]) : m)) : s);
  const T = (k, fr, vars) => {
    const d = window.C2V_I18N, v = d && d[k];
    return fill(typeof v === 'string' && v && !MISSING.test(v) ? unescHtml(v) : fr, vars);
  };
  // meme appel que T, toujours en francais (textes pour l'equipe : proprietes cachees, fiche client)
  const TFr = (k, fr, vars) => fill(fr, vars);
  let PR = null;
  try { PR = new Intl.PluralRules(INTL); } catch (e) { /* pluriel francais */ }
  // pluriel : cle_one, cle_other (+ cle_few, cle_many... selon les regles CLDR de la langue)
  const TP = (k, n, one, other, vars) => {
    const d = window.C2V_I18N || {}, ok = x => typeof d[x] === 'string' && !!d[x] && !MISSING.test(d[x]);
    const cat = PR ? PR.select(n) : (n > 1 ? 'other' : 'one');
    return T(ok(k + '_' + cat) ? k + '_' + cat : k + (n > 1 ? '_other' : '_one'), n > 1 ? other : one, vars);
  };

  /* ---------------------------------------------------------------- Reglages */
  const SILICONES = [
    { id: 'naturel', name: 'Naturel translucide', hex: null },
    { id: 'rose', name: 'Rose bonbon', hex: '#F4A3C6' },
    { id: 'fuchsia', name: 'Fuchsia', hex: '#D6246E' },
    { id: 'violet', name: 'Violet', hex: '#7B4BC9' },
    { id: 'bleu', name: 'Bleu électrique', hex: '#2D6CF0' }
  ];
  const INKS = [
    { id: 'blanc', name: 'Blanc', hex: '#FFFFFF' },
    { id: 'noir', name: 'Noir', hex: '#111111' },
    { id: 'bordeaux', name: 'Bordeaux', hex: '#AD5067' },
    { id: 'fuchsia', name: 'Fuchsia', hex: '#D6246E' },
    { id: 'bleu', name: 'Bleu électrique', hex: '#2D6CF0' }
  ];
  const NATUREL_REF = '#E6E6E8';
  // produits a plat : par defaut le logo est imprime avec ses couleurs d'origine
  const ORIG_INK = { id: 'orig', name: "Couleurs d'origine", hex: null };
  // noms affiches (traduits) des couleurs fixes ; .name reste le nom francais (fiche client, equipe)
  const COLOR_LABELS = {
    naturel: T('studio.color_naturel', 'Naturel translucide'),
    rose: T('studio.color_rose', 'Rose bonbon'),
    fuchsia: T('studio.color_fuchsia', 'Fuchsia'),
    violet: T('studio.color_violet', 'Violet'),
    bleu: T('studio.color_bleu', 'Bleu électrique'),
    blanc: T('studio.color_blanc', 'Blanc'),
    noir: T('studio.color_noir', 'Noir'),
    bordeaux: T('studio.color_bordeaux', 'Bordeaux'),
    orig: T('studio.color_orig', "Couleurs d'origine"),
    custom: T('studio.color_custom', 'Couleur sur mesure')
  };
  // nom affiche d'une couleur : couleurs fixes, sur mesure, ou couleur du modele (label traduit)
  const cname = c => (c ? c.label || COLOR_LABELS[c.id] || c.name || '' : '');
  const ZONE_W = 639, ZONE_H = 429, ZONE_PAD = 0.05, ZONE_RATIO = ZONE_W / ZONE_H;
  const MAX_FILE = 20 * 1024 * 1024;
  const PDFJS = [
    ['https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.min.mjs', 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs'],
    ['https://cdn.jsdelivr.net/npm/pdfjs-dist@4.4.168/build/pdf.min.mjs', 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs']
  ];
  const SUBS = [T('studio.color', 'Couleur'), T('studio.logo', 'Logo'), T('studio.pack', 'Emballage'), T('studio.quantity', 'Quantité')];

  /* Geometrie mesuree sur les rendus sources 2048 px */
  const G3 = {
    ox: 443, oy: 207, srcW: 1151, cx: 1018.5, cy: 494, ax: 553, by: 266, k: 0.07, clip: 0.95,
    u0: -0.622, u1: 0.614, v0: -0.474, v1: 0.354, yFull: 760, yNone: 1045, yLb: 700,
    tubeTop: [863.5, 449, 74, 31], tubeBody: [790, 449, 937, 598], tubeBase: [866, 598, 78, 26]
  };
  const GT = { hx: 0.515, hy: 0.787, hr: 0.058, zx0: 0.189, zy0: 0.263, zx1: 0.807, zy1: 0.677 };
  const GP = { ox: 313, oy: 58, srcW: 1521, x: 358, y: 101.3, w: 1370, h: 1761.4 };

  /* ------------------------------------------------------------- Utilitaires */
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  // nombres et prix selon la langue de la page (fr-FR en francais, comme avant)
  const nf = (loc, o) => { try { return new Intl.NumberFormat(loc, o); } catch (e) { return new Intl.NumberFormat('fr-FR', o); } };
  const EUR = nf(INTL, { style: 'currency', currency: 'EUR' });
  const NUM = nf(INTL);
  const money = v => EUR.format(Math.round(v * 100) / 100);
  // textes pour l'equipe (proprietes cachees, apercu joint, fiche client) : toujours au format francais
  const EUR_FR = nf('fr-FR', { style: 'currency', currency: 'EUR' });
  const NUM_FR = nf('fr-FR');
  const moneyFr = v => EUR_FR.format(Math.round(v * 100) / 100);
  // separateur decimal de la langue (virgule en francais)
  const DEC = NUM.format(1.5).replace(/\d/g, '') || ',';
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Police des titres (DeMonte) : fichiers de police corriges le 10/10/2026
  // (accents aigus et graves remis dans le bon sens). dm() ne transforme plus
  // le texte ; garde pour compatibilite avec les appels existants.
  const dm = s => String(s);
  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const hexToRgb = h => {
    h = String(h).replace('#', '').trim();
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  };
  const rgbToHex = rgb => '#' + rgb.map(v => clamp(Math.round(v), 0, 255).toString(16).padStart(2, '0')).join('').toUpperCase();
  const isHex = h => /^#?[0-9a-f]{6}$/i.test(String(h).trim());
  const relLum = rgb => {
    const c = rgb.map(v => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };
  const contrast = (a, b) => { const la = relLum(a), lb = relLum(b); return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05); };
  const hsvToRgb = (h, s, v) => {
    const f = n => { const k = (n + h / 60) % 6; return v - v * s * Math.max(0, Math.min(k, 4 - k, 1)); };
    return [f(5) * 255, f(3) * 255, f(1) * 255];
  };
  const rgbToHsv = ([r, g, b]) => {
    r /= 255; g /= 255; b /= 255;
    const mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    let h = 0;
    if (d) {
      if (mx === r) h = ((g - b) / d) % 6; else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60; if (h < 0) h += 360;
    }
    return [h, mx ? d / mx : 0, mx];
  };
  const makeCanvas = (w, h) => { const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; };
  const ctx2d = c => c.getContext('2d', { willReadFrequently: true });
  const medianHist = (hist, count, fallback) => {
    if (!count) return fallback;
    let acc = 0;
    for (let v = 0; v < hist.length; v++) { acc += hist[v]; if (acc >= count / 2) return v + 0.5; }
    return fallback;
  };
  const loadImg = (url, cors) => new Promise((res, rej) => {
    const im = new Image();
    if (cors) im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    im.onload = () => res(im);
    im.onerror = () => rej(new Error('image'));
    im.src = url;
  });
  const loadScript = src => new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = res; s.onerror = () => rej(new Error('script ' + src));
    document.head.appendChild(s);
  });

  /* Images du studio : fichiers Shopify (Contenu > Fichiers), charges en CORS
     pour pouvoir relire les pixels du canvas. Ancien format (base64 decoupe
     en fichiers JS) garde en secours si "parts" est fourni. */
  const imageCache = {};
  function loadStudioImage(key, spec) {
    // cle = vue + fichier : plusieurs produits (page d'accueil) partagent la vue "flat"
    const id = key + '|' + (spec ? spec.src || (spec.parts || []).join(',') : '');
    if (imageCache[id]) return imageCache[id];
    let p;
    if (!spec) p = Promise.reject(new Error('missing ' + key));
    else if (spec.src) p = loadImg(spec.src, !/^(data|blob):/.test(spec.src));
    else {
      p = Promise.all(spec.parts.map(loadScript)).then(() => {
        const bank = window.C2V_IMG || {};
        const b64 = spec.parts.map((_, i) => bank[key + '-' + (i + 1)] || '').join('');
        return loadImg('data:' + (spec.type || 'image/avif') + ';base64,' + b64);
      });
    }
    imageCache[id] = p;
    p.catch(() => { delete imageCache[id]; });
    return p;
  }

  /* pdf.js, charge uniquement quand un PDF est importe */
  let pdfjsPromise = null;
  function loadPdfjs() {
    if (pdfjsPromise) return pdfjsPromise;
    pdfjsPromise = (async () => {
      for (const [lib, worker] of PDFJS) {
        try {
          const m = await import(lib);
          m.GlobalWorkerOptions.workerSrc = worker;
          return m;
        } catch (e) { /* essai suivant */ }
      }
      throw new Error('pdfjs');
    })();
    pdfjsPromise.catch(() => { pdfjsPromise = null; });
    return pdfjsPromise;
  }
  async function renderPdf(file, targetLong, background) {
    const pdfjs = await loadPdfjs();
    const data = new Uint8Array(await file.arrayBuffer());
    const doc = await pdfjs.getDocument({ data, isEvalSupported: false }).promise;
    const page = await doc.getPage(1);
    const vp1 = page.getViewport({ scale: 1 });
    const scale = targetLong / Math.max(vp1.width, vp1.height);
    const vp = page.getViewport({ scale });
    const c = makeCanvas(vp.width, vp.height);
    await page.render({ canvasContext: ctx2d(c), viewport: vp, background }).promise;
    const out = { canvas: c, wPt: vp1.width, hPt: vp1.height, pages: doc.numPages };
    doc.destroy();
    return out;
  }

  /* ------------------------------------------------------ Moteur de rendu */
  // Teinte : la luminance du rendu blanc sert de carte d'ombrage (effet givre conserve)
  function tintPass(src, out, L, Wt, n, Lb, rgb, strength) {
    if (!rgb || strength <= 0.001) { out.set(src.subarray(0, n * 4)); return; }
    const cr = rgb[0], cg = rgb[1], cb = rgb[2];
    const k2 = Math.max(0.001, 255 / Lb - 1);
    for (let i = 0, p = 0; i < n; i++, p += 4) {
      const w = Wt[i] * strength;
      if (w <= 0) { out[p] = src[p]; out[p + 1] = src[p + 1]; out[p + 2] = src[p + 2]; continue; }
      const f = L[i] / Lb;
      let r, g, b;
      if (f <= 1) { r = cr * f; g = cg * f; b = cb * f; }
      else { const t = f - 1 >= k2 ? 1 : (f - 1) / k2; r = cr + (255 - cr) * t; g = cg + (255 - cg) * t; b = cb + (255 - cb) * t; }
      const iw = 1 - w;
      out[p] = src[p] * iw + r * w;
      out[p + 1] = src[p + 1] * iw + g * w;
      out[p + 2] = src[p + 2] * iw + b * w;
    }
  }
  // Logo : aplat 1 couleur, legerement module par l'ombrage du silicone
  function logoPass(out, L, Lb, map, zone, ink, opacity) {
    const I = map.I, U = map.U, V = map.V, C = map.C, n = map.n;
    const m = zone.m, zw = zone.w, zh = zone.h;
    const ir = ink[0], ig = ink[1], ib = ink[2];
    for (let j = 0; j < n; j++) {
      const fx = U[j] * (zw - 1), fy = V[j] * (zh - 1);
      const x0 = fx | 0, y0 = fy | 0;
      const x1 = x0 + 1 < zw ? x0 + 1 : x0, y1 = y0 + 1 < zh ? y0 + 1 : y0;
      const ax = fx - x0, ay = fy - y0, r0 = y0 * zw, r1 = y1 * zw;
      const v = (m[r0 + x0] * (1 - ax) + m[r0 + x1] * ax) * (1 - ay) + (m[r1 + x0] * (1 - ax) + m[r1 + x1] * ax) * ay;
      if (v < 0.004) continue;
      const a = v * C[j] * opacity, i = I[j], p = i * 4;
      let f = L[i] / Lb; f = f < 0 ? 0 : f > 1.2 ? 1.2 : f;
      const sh = 0.85 + 0.15 * f, ia = 1 - a;
      out[p] = out[p] * ia + ir * sh * a;
      out[p + 1] = out[p + 1] * ia + ig * sh * a;
      out[p + 2] = out[p + 2] * ia + ib * sh * a;
    }
  }

  class Lid3D {
    constructor(img) {
      const W = img.naturalWidth, H = img.naturalHeight, s = W / G3.srcW;
      this.W = W; this.H = H; this.s = s;
      const c = makeCanvas(W, H), cx = ctx2d(c);
      cx.drawImage(img, 0, 0, W, H);
      const d = this.src = cx.getImageData(0, 0, W, H).data;
      this.out = cx.createImageData(W, H); this.out.data.set(d);
      const Y = v => (v - G3.oy) * s, X = v => (v - G3.ox) * s;
      const yFull = Y(G3.yFull), yNone = Y(G3.yNone), yLb = Y(G3.yLb);
      const rows = Math.min(H, Math.ceil(yNone) + 2);
      this.n = rows * W;
      const L = this.L = new Float32Array(this.n), Wt = this.Wt = new Float32Array(this.n);
      const hist = new Uint32Array(256); let hc = 0;
      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < W; x++) {
          const i = y * W + x, p = i * 4, r = d[p], g = d[p + 1], b = d[p + 2], a = d[p + 3];
          const l = (r + g + b) / 3; L[i] = l;
          let w = 0;
          if (a > 10) {
            if (y < yFull) w = 1;
            else if (y <= yNone) { const sat = Math.max(r, g, b) - Math.min(r, g, b); w = clamp(1 - (sat - 18) / 55, 0, 1); }
          }
          Wt[i] = w;
          if (w > 0.99 && y < yLb && a > 250) { hist[l | 0]++; hc++; }
        }
      }
      this.Lb = medianHist(hist, hc, 200);
      this.map = this.buildMap(X, Y);
    }
    tubeAt(xo, yo) {
      const t = G3.tubeTop, b = G3.tubeBody, s = G3.tubeBase;
      if (((xo - t[0]) / t[2]) ** 2 + ((yo - t[1]) / t[3]) ** 2 <= 1) return 1;
      if (xo >= b[0] && xo <= b[2] && yo >= b[1] && yo <= b[3]) return 1;
      if (((xo - s[0]) / s[2]) ** 2 + ((yo - s[1]) / s[3]) ** 2 <= 1) return 1;
      return 0;
    }
    tube(x, y) {
      const s = this.s, xo = x / s + G3.ox, yo = y / s + G3.oy;
      if (xo < 778 || xo > 954 || yo < 408 || yo > 634) return 0;
      let c = 0;
      for (let a = 0; a < 3; a++) for (let b = 0; b < 3; b++) c += this.tubeAt((x + (a + 0.5) / 3) / s + G3.ox, (y + (b + 0.5) / 3) / s + G3.oy);
      return c / 9;
    }
    buildMap(X, Y) {
      const s = this.s, W = this.W;
      const cx = X(G3.cx), cy = Y(G3.cy), ax = G3.ax * s, by = G3.by * s;
      const x0 = Math.max(0, Math.floor(cx - ax)), x1 = Math.min(W - 1, Math.ceil(cx + ax));
      const y0 = Math.max(0, Math.floor(cy - by)), y1 = Math.min(this.H - 1, Math.ceil(cy + by));
      const cap = (x1 - x0 + 1) * (y1 - y0 + 1);
      const I = new Int32Array(cap), U = new Float32Array(cap), V = new Float32Array(cap), C = new Float32Array(cap);
      const du = G3.u1 - G3.u0, dv = G3.v1 - G3.v0, clip = G3.clip;
      let n = 0;
      for (let y = y0; y <= y1; y++) {
        const v = (y + 0.5 - cy) / by;
        for (let x = x0; x <= x1; x++) {
          const xn = (x + 0.5 - cx) / ax, e = xn * xn + v * v;
          if (e > clip) continue;
          const u = xn / (1 + G3.k * v);
          const zu = (u - G3.u0) / du, zv = (v - G3.v0) / dv;
          if (zu < 0 || zu > 1 || zv < 0 || zv > 1) continue;
          const t = this.tube(x, y);
          if (t >= 1) continue;
          I[n] = y * W + x; U[n] = zu; V[n] = zv; C[n] = Math.min(1, (clip - e) / 0.025) * (1 - t); n++;
        }
      }
      return { I, U, V, C, n };
    }
    render(ctx, rgb, strength, zone, ink) {
      const o = this.out.data;
      tintPass(this.src, o, this.L, this.Wt, this.n, this.Lb, rgb, strength);
      if (zone) logoPass(o, this.L, this.Lb, this.map, zone, ink, 0.95);
      ctx.putImageData(this.out, 0, 0);
    }
  }

  class TopView {
    constructor(img) {
      const S = img.naturalWidth, H = img.naturalHeight;
      this.W = S; this.H = H;
      const c = makeCanvas(S, H), cx = ctx2d(c);
      cx.drawImage(img, 0, 0, S, H);
      const d = this.src = cx.getImageData(0, 0, S, H).data;
      this.out = cx.createImageData(S, H); this.out.data.set(d);
      this.n = S * H;
      const L = this.L = new Float32Array(this.n), Wt = this.Wt = new Float32Array(this.n);
      const hx = GT.hx * S, hy = GT.hy * S, hr = GT.hr * S;
      const hist = new Uint32Array(256); let hc = 0;
      for (let y = 0; y < H; y++) {
        for (let x = 0; x < S; x++) {
          const i = y * S + x, p = i * 4;
          const l = (d[p] + d[p + 1] + d[p + 2]) / 3; L[i] = l;
          const hole = clamp((hr - Math.hypot(x - hx, y - hy)) / 2, 0, 1);
          Wt[i] = 1 - hole;
          if (d[p + 3] > 200 && hole === 0) { hist[l | 0]++; hc++; }
        }
      }
      this.Lb = medianHist(hist, hc, 200);
      const zx0 = GT.zx0 * S, zy0 = GT.zy0 * S, zw = (GT.zx1 - GT.zx0) * S, zh = (GT.zy1 - GT.zy0) * S;
      const X0 = Math.floor(zx0), X1 = Math.ceil(zx0 + zw), Y0 = Math.floor(zy0), Y1 = Math.ceil(zy0 + zh);
      const cap = (X1 - X0) * (Y1 - Y0);
      const I = new Int32Array(cap), U = new Float32Array(cap), V = new Float32Array(cap), C = new Float32Array(cap);
      let n = 0;
      for (let y = Y0; y < Y1; y++) {
        for (let x = X0; x < X1; x++) {
          const zu = (x + 0.5 - zx0) / zw, zv = (y + 0.5 - zy0) / zh;
          if (zu < 0 || zu > 1 || zv < 0 || zv > 1) continue;
          const i = y * S + x;
          if (d[i * 4 + 3] < 10) continue;
          I[n] = i; U[n] = zu; V[n] = zv; C[n] = 1; n++;
        }
      }
      this.map = { I, U, V, C, n };
    }
    render(ctx, rgb, strength, zone, ink) {
      const o = this.out.data;
      tintPass(this.src, o, this.L, this.Wt, this.n, this.Lb, rgb, strength);
      if (zone) logoPass(o, this.L, this.Lb, this.map, zone, ink, 0.96);
      ctx.putImageData(this.out, 0, 0);
    }
  }

  class Pack {
    constructor(img) {
      const W = img.naturalWidth, H = img.naturalHeight, s = W / GP.srcW;
      this.W = W; this.H = H;
      const c = makeCanvas(W, H), cx = ctx2d(c);
      cx.drawImage(img, 0, 0, W, H);
      this.src = cx.getImageData(0, 0, W, H).data;
      this.out = cx.createImageData(W, H); this.out.data.set(this.src);
      const x = Math.round((GP.x - GP.ox) * s), y = Math.round((GP.y - GP.oy) * s);
      const w = Math.round(GP.w * s), h = Math.round(GP.h * s);
      this.rect = { x, y, w, h };
      // ombrage du papier (plis, grain) applique au visuel en multiplication
      const shade = this.shade = new Float32Array(w * h);
      const hist = new Uint32Array(256); let hc = 0;
      for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
        const p = ((y + j) * W + x + i) * 4, l = (this.src[p] + this.src[p + 1] + this.src[p + 2]) / 3;
        shade[j * w + i] = l; hist[l | 0]++; hc++;
      }
      const med = medianHist(hist, hc, 230);
      for (let k = 0; k < shade.length; k++) shade[k] = clamp(shade[k] / med, 0, 1.1);
    }
    setVisual(visual) {
      const o = this.out.data;
      o.set(this.src);
      if (!visual) return;
      const { x, y, w, h } = this.rect, W = this.W;
      const t = makeCanvas(w, h), tc = ctx2d(t);
      tc.fillStyle = '#fff'; tc.fillRect(0, 0, w, h);
      const k = Math.min(w / visual.width, h / visual.height);
      const dw = visual.width * k, dh = visual.height * k;
      tc.imageSmoothingQuality = 'high';
      tc.drawImage(visual, (w - dw) / 2, (h - dh) / 2, dw, dh);
      const v = tc.getImageData(0, 0, w, h).data;
      for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
        const q = (j * w + i), p = ((y + j) * W + x + i) * 4, sh = this.shade[q];
        o[p] = v[q * 4] * sh; o[p + 1] = v[q * 4 + 1] * sh; o[p + 2] = v[q * 4 + 2] * sh;
      }
    }
    render(ctx) { ctx.putImageData(this.out, 0, 0); }
  }

  /* Produit a plat (sachet, sifflet...) : image detouree + zone d'impression.
     model.zone = [x, y, w, h] en pixels de l'image source (model.size), model.mm = format d'impression.
     La zone utile garde exactement le ratio du format en mm, centree dans la zone mesuree. */
  function flatBox(model, W, H) {
    const size = model.size || [W, H], s = W ? W / size[0] : 1;
    const z = (model.zone || [0, 0, size[0], size[1]]).map(v => v * s);
    const r = model.mm && model.mm[1] ? model.mm[0] / model.mm[1] : z[2] / z[3];
    let w = z[2], h = z[2] / r;
    if (h > z[3]) { h = z[3]; w = z[3] * r; }
    return { x: Math.round(z[0] + (z[2] - w) / 2), y: Math.round(z[1] + (z[3] - h) / 2), w: Math.max(1, Math.round(w)), h: Math.max(1, Math.round(h)) };
  }
  class FlatView {
    constructor(img, model) {
      const W = img.naturalWidth, H = img.naturalHeight;
      this.W = W; this.H = H; this.model = model;
      const c = makeCanvas(W, H), cx = ctx2d(c);
      cx.drawImage(img, 0, 0, W, H);
      this.src = cx.getImageData(0, 0, W, H).data;
      this.out = cx.createImageData(W, H); this.out.data.set(this.src);
      this.box = flatBox(model, W, H);
      this.relief = !!model.relief;
      const { x, y, w, h } = this.box;
      // ombrage de la matiere (plis, grain, texture) applique au marquage en multiplication
      const shade = this.shade = new Float32Array(w * h), alpha = this.alpha = new Float32Array(w * h);
      const hist = new Uint32Array(256); let hc = 0;
      for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
        const q = j * w + i, p = ((y + j) * W + x + i) * 4, l = (this.src[p] + this.src[p + 1] + this.src[p + 2]) / 3;
        shade[q] = l; alpha[q] = this.src[p + 3] / 255;
        if (alpha[q] > 0.9) { hist[l | 0]++; hc++; }
      }
      const med = medianHist(hist, hc, 235);
      for (let k = 0; k < shade.length; k++) shade[k] = clamp(shade[k] / med, 0, 1.08);
      if (model.colorStep) this.initTint(model.colorStep);
    }
    /* Couleur d'une partie du produit (ex. bouchons d'oreille, modele.colorStep) :
       masque calcule une fois d'apres la teinte de la photo dans une zone donnee,
       puis recoloration en gardant les ombres et la texture (luminance relative). */
    initTint(spec) {
      const W = this.W, H = this.H, size = this.model.size || [W, H], k = W / size[0];
      const b = (spec.box || [0, 0, size[0], size[1]]).map(v => Math.round(v * k));
      const x0 = clamp(b[0], 0, W), y0 = clamp(b[1], 0, H), x1 = clamp(b[0] + b[2], 0, W), y1 = clamp(b[1] + b[3], 0, H);
      const [h0, h1] = spec.hue || [18, 42];
      const ss = (e0, e1, v) => { const t = clamp((v - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
      const src = this.src, idx = [], mask = [], lum = [];
      for (let y = y0; y < y1; y++) for (let x = x0; x < x1; x++) {
        const p = (y * W + x) * 4;
        if (src[p + 3] < 128) continue;
        const r = src[p] / 255, g = src[p + 1] / 255, bl = src[p + 2] / 255;
        const mx = Math.max(r, g, bl), mn = Math.min(r, g, bl), d = mx - mn;
        if (d < 1e-4 || mx < 0.12) continue;
        const s = d / mx;
        let h = mx === r ? ((g - bl) / d) % 6 : mx === g ? (bl - r) / d + 2 : (r - g) / d + 4;
        h *= 60; if (h < 0) h += 360;
        const m = ss(0.08, 0.2, s) * ss(h0 - 8, h0, h) * (1 - ss(h1, h1 + 10, h));
        if (m <= 0.01) continue;
        idx.push(p); mask.push(m); lum.push(0.299 * r + 0.587 * g + 0.114 * bl);
      }
      const core = lum.filter((l, i) => mask[i] > 0.9).sort((a, b2) => a - b2);
      const ref = core.length ? core[core.length >> 1] : 0.74;
      this.tint = { idx: Int32Array.from(idx), mask: Float32Array.from(mask), k: Float32Array.from(lum, l => l / ref) };
      this.orig = this.src.slice ? this.src.slice() : new Uint8ClampedArray(this.src);
      this.tintHex = null;
    }
    // hex = couleur cible ; null = couleur d'origine de la photo
    setTint(hex) {
      const t = this.tint;
      if (!t || hex === this.tintHex) return;
      this.tintHex = hex;
      const src = this.src, orig = this.orig;
      if (!hex) { for (let n = 0; n < t.idx.length; n++) { const p = t.idx[n]; src[p] = orig[p]; src[p + 1] = orig[p + 1]; src[p + 2] = orig[p + 2]; } return; }
      const T = hexToRgb(hex).map(v => v / 255);
      for (let n = 0; n < t.idx.length; n++) {
        const p = t.idx[n], m = t.mask[n], k = t.k[n];
        for (let c = 0; c < 3; c++) {
          const v = k <= 1 ? T[c] * k : T[c] + (1 - T[c]) * Math.min(1, (k - 1) * 1.6);
          src[p + c] = orig[p + c] * (1 - m) + v * 255 * m;
        }
      }
    }
    // art = { mode: 'logo' | 'visuel', canvas } ; empty = { title, sub, font } pour la zone vide
    render(ctx, art, empty) {
      const o = this.out.data, W = this.W;
      o.set(this.src);
      const { x, y, w, h } = this.box;
      if (art && art.canvas) {
        const t = makeCanvas(w, h), tc = ctx2d(t);
        if (art.mode === 'visuel') { tc.fillStyle = '#fff'; tc.fillRect(0, 0, w, h); }
        const k = Math.min(w / art.canvas.width, h / art.canvas.height);
        const dw = art.canvas.width * k, dh = art.canvas.height * k;
        tc.imageSmoothingQuality = 'high';
        tc.drawImage(art.canvas, (w - dw) / 2, (h - dh) / 2, dw, dh);
        const v = tc.getImageData(0, 0, w, h).data;
        // relief : eclairage en haut a gauche, ombre portee en bas a droite des contours du logo
        let emb = null;
        if (this.relief && art.mode === 'logo') {
          emb = new Float32Array(w * h);
          const d = Math.max(1, Math.round(Math.min(w, h) / 140));
          const A = (i, j) => (i < 0 || j < 0 || i >= w || j >= h) ? 0 : v[(j * w + i) * 4 + 3];
          for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
            const e = (A(i + d, j + d) - A(i - d, j - d) + 0.5 * (A(i + 2 * d, j + 2 * d) - A(i - 2 * d, j - 2 * d))) / 382;
            emb[j * w + i] = e;
          }
        }
        for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
          const q = j * w + i, pa = this.alpha[q];
          if (pa <= 0.02) continue;
          const p = ((y + j) * W + x + i) * 4, sh = this.shade[q], a = (v[q * 4 + 3] / 255) * (pa > 0.98 ? 1 : pa), ia = 1 - a;
          let r = o[p] * ia + v[q * 4] * sh * a, g = o[p + 1] * ia + v[q * 4 + 1] * sh * a, b = o[p + 2] * ia + v[q * 4 + 2] * sh * a;
          if (emb) {
            const e = emb[q];
            if (e > 0.004) { const f = 0.42 * e; r += (255 - r) * f; g += (255 - g) * f; b += (255 - b) * f; }
            else if (e < -0.004) { const f = 1 + 0.38 * e; r *= f; g *= f; b *= f; }
          }
          o[p] = r; o[p + 1] = g; o[p + 2] = b;
        }
        ctx.putImageData(this.out, 0, 0);
        return;
      }
      ctx.putImageData(this.out, 0, 0);
      if (!empty) return;
      this.drawEmpty(ctx, this.box, empty, W, this.H);
    }
    // zone d'impression vide : cadre pointille + format (box dans le repere du canvas de destination)
    drawEmpty(ctx, box, empty, W, H) {
      const { x, y, w, h } = box;
      const lw = Math.max(2, Math.round(Math.min(W, H) / 380));
      ctx.save();
      ctx.strokeStyle = 'rgba(173, 80, 103, 0.62)'; ctx.lineWidth = lw;
      ctx.setLineDash([lw * 4, lw * 3]);
      ctx.strokeRect(x + lw, y + lw, w - 2 * lw, h - 2 * lw);
      ctx.fillStyle = 'rgba(255, 241, 245, 0.55)'; ctx.fillRect(x + lw * 2, y + lw * 2, w - lw * 4, h - lw * 4);
      const fs = clamp(Math.min(w / 7.5, h / 4.2), 14, 64), font = empty.font || 'sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = '#AD5067';
      ctx.font = `500 ${Math.round(fs)}px ${font}`;
      ctx.fillText(empty.title, x + w / 2, y + h / 2 - fs * 0.45, w * 0.9);
      ctx.fillStyle = 'rgba(173, 80, 103, 0.8)'; ctx.font = `400 ${Math.round(fs * 0.68)}px ${font}`;
      ctx.fillText(empty.sub, x + w / 2, y + h / 2 + fs * 0.55, w * 0.9);
      ctx.restore();
    }
  }

  /* ------------------------------------------------------ Analyse du logo */
  function fileKind(file) {
    const n = (file.name || '').toLowerCase(), t = (file.type || '').toLowerCase();
    if (t === 'application/pdf' || n.endsWith('.pdf')) return 'pdf';
    if (t === 'image/svg+xml' || n.endsWith('.svg')) return 'svg';
    if (/^image\/(png|jpe?g|webp|gif)$/.test(t) || /\.(png|jpe?g|webp|gif)$/.test(n)) return 'raster';
    return null;
  }
  async function svgSource(file) {
    const txt = await file.text();
    const doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
    const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw new Error('svg');
    const vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const wa = svg.getAttribute('width') || '', ha = svg.getAttribute('height') || '';
    let w = /%/.test(wa) ? NaN : parseFloat(wa), h = /%/.test(ha) ? NaN : parseFloat(ha);
    const hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
    if (!(w > 0 && h > 0)) { if (hasVb) { w = vb[2]; h = vb[3]; } else { w = 1000; h = 1000; } }
    if (!hasVb) svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    const k = 2000 / Math.max(w, h);
    svg.setAttribute('width', String(w * k));
    svg.setAttribute('height', String(h * k));
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    try { const im = await loadImg(url); return { src: im, w: w * k, h: h * k }; }
    finally { setTimeout(() => URL.revokeObjectURL(url), 4000); }
  }
  async function rasterSource(file) {
    const url = URL.createObjectURL(file);
    try { const im = await loadImg(url); return { src: im, w: im.naturalWidth, h: im.naturalHeight }; }
    finally { setTimeout(() => URL.revokeObjectURL(url), 4000); }
  }
  function borderMedian(d, w, h) {
    const hs = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    let c = 0;
    const add = (x, y) => { const p = (y * w + x) * 4; hs[0][d[p]]++; hs[1][d[p + 1]]++; hs[2][d[p + 2]]++; c++; };
    const sx = Math.max(1, Math.floor(w / 200)), sy = Math.max(1, Math.floor(h / 200));
    for (let x = 0; x < w; x += sx) { add(x, 0); add(x, h - 1); }
    for (let y = 0; y < h; y += sy) { add(0, y); add(w - 1, y); }
    return hs.map(hh => medianHist(hh, c, 255));
  }
  // Plusieurs couleurs franches dans le logo ?
  function detectMulti(d, include, n) {
    const buckets = new Map();
    let tot = 0;
    const step = Math.max(1, Math.floor(n / 80000));
    for (let i = 0; i < n; i += step) {
      if (!include(i)) continue;
      const p = i * 4, key = ((d[p] >> 5) << 6) | ((d[p + 1] >> 5) << 3) | (d[p + 2] >> 5);
      buckets.set(key, (buckets.get(key) || 0) + 1); tot++;
    }
    if (tot < 60) return false;
    const list = Array.from(buckets.entries())
      .map(([k, c]) => ({ r: ((k >> 6) & 7) * 32 + 16, g: ((k >> 3) & 7) * 32 + 16, b: (k & 7) * 32 + 16, c }))
      .sort((a, b) => b.c - a.c);
    const clusters = [];
    for (const b of list) {
      const hit = clusters.find(c => Math.hypot(c.r - b.r, c.g - b.g, c.b - b.b) < 75);
      if (hit) hit.c += b.c; else clusters.push(Object.assign({}, b));
    }
    return clusters.filter(c => c.c / tot > 0.06).length >= 2;
  }
  function analyzeLogo(source, sw, sh) {
    const k = Math.min(1, 1400 / Math.max(sw, sh));
    const w = Math.max(1, Math.round(sw * k)), h = Math.max(1, Math.round(sh * k));
    const c = makeCanvas(w, h), cx = ctx2d(c);
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(source, 0, 0, w, h);
    const d = cx.getImageData(0, 0, w, h).data, n = w * h;
    let transp = 0;
    for (let i = 0; i < n; i++) if (d[i * 4 + 3] < 250) transp++;
    const hasAlpha = transp > n * 0.01;
    const mask = new Float32Array(n);
    let include;
    if (hasAlpha) {
      let op = 0, wh = 0;
      for (let i = 0, p = 0; i < n; i++, p += 4) if (d[p + 3] > 200) { op++; if (Math.min(d[p], d[p + 1], d[p + 2]) > 235) wh++; }
      const whiteLogo = op > 0 && wh / op > 0.97;
      for (let i = 0, p = 0; i < n; i++, p += 4) {
        const a = d[p + 3] / 255;
        mask[i] = whiteLogo ? a : a * clamp((255 - Math.min(d[p], d[p + 1], d[p + 2]) - 12) / 40, 0, 1);
      }
      include = i => d[i * 4 + 3] > 200;
    } else {
      const bg = borderMedian(d, w, h);
      for (let i = 0, p = 0; i < n; i++, p += 4) {
        const dist = Math.hypot(d[p] - bg[0], d[p + 1] - bg[1], d[p + 2] - bg[2]);
        mask[i] = clamp((dist - 24) / 48, 0, 1);
      }
      include = i => mask[i] > 0.7;
    }
    let x0 = w, y0 = h, x1 = -1, y1 = -1, cov = 0;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const v = mask[y * w + x]; cov += v;
      if (v > 0.08) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return { empty: true };
    return { w, h, k, mask, bbox: [x0, y0, x1, y1], cov: cov / n, multi: detectMulti(d, include, n) };
  }
  // Silhouette recadree puis calee sans deformation dans la zone 639 x 429
  function buildZone(an) {
    const [x0, y0, x1, y1] = an.bbox, bw = x1 - x0 + 1, bh = y1 - y0 + 1;
    const sil = makeCanvas(bw, bh), sc = ctx2d(sil), im = sc.createImageData(bw, bh);
    for (let y = 0; y < bh; y++) for (let x = 0; x < bw; x++) {
      const q = (y * bw + x) * 4;
      im.data[q] = im.data[q + 1] = im.data[q + 2] = 255;
      im.data[q + 3] = an.mask[(y + y0) * an.w + x + x0] * 255;
    }
    sc.putImageData(im, 0, 0);
    const z = makeCanvas(ZONE_W, ZONE_H), zc = ctx2d(z);
    zc.imageSmoothingQuality = 'high';
    const s = Math.min(ZONE_W * (1 - 2 * ZONE_PAD) / bw, ZONE_H * (1 - 2 * ZONE_PAD) / bh);
    zc.drawImage(sil, (ZONE_W - bw * s) / 2, (ZONE_H - bh * s) / 2, bw * s, bh * s);
    const zd = zc.getImageData(0, 0, ZONE_W, ZONE_H).data, m = new Float32Array(ZONE_W * ZONE_H);
    for (let i = 0; i < m.length; i++) m[i] = zd[i * 4 + 3] / 255;
    return { m, w: ZONE_W, h: ZONE_H, sil, bw, bh };
  }

  // Logo en couleurs (produits a plat) : transparence conservee, sinon fond uni retire, recadre sur le motif
  function colorLogo(source, sw, sh) {
    const k = Math.min(1, 1600 / Math.max(sw, sh));
    const w = Math.max(1, Math.round(sw * k)), h = Math.max(1, Math.round(sh * k));
    const c = makeCanvas(w, h), cx = ctx2d(c);
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(source, 0, 0, w, h);
    const im = cx.getImageData(0, 0, w, h), d = im.data, n = w * h;
    let transp = 0;
    for (let i = 0; i < n; i++) if (d[i * 4 + 3] < 250) transp++;
    const hasAlpha = transp > n * 0.01;
    if (!hasAlpha) {
      const bg = borderMedian(d, w, h);
      for (let i = 0, p = 0; i < n; i++, p += 4) {
        const dist = Math.hypot(d[p] - bg[0], d[p + 1] - bg[1], d[p + 2] - bg[2]);
        d[p + 3] = Math.round(255 * clamp((dist - 24) / 48, 0, 1));
      }
    }
    let x0 = w, y0 = h, x1 = -1, y1 = -1, cov = 0, op = 0, wh = 0;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const p = (y * w + x) * 4, a = d[p + 3];
      cov += a;
      if (a > 20) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      if (a > 200) { op++; if (Math.min(d[p], d[p + 1], d[p + 2]) > 225) wh++; }
    }
    if (x1 < 0) return { empty: true };
    cx.putImageData(im, 0, 0);
    const bw = x1 - x0 + 1, bh = y1 - y0 + 1, out = makeCanvas(bw, bh);
    ctx2d(out).drawImage(c, x0, y0, bw, bh, 0, 0, bw, bh);
    return { canvas: out, k, bw: bw / k, bh: bh / k, cov: cov / 255 / n, white: op > 0 && wh / op > 0.9, hasAlpha, multi: detectMulti(d, i => d[i * 4 + 3] > 200, n) };
  }
  // Logo converti en une seule couleur (comme la capote) : les zones blanches deviennent transparentes,
  // sauf pour un logo entierement blanc
  function monoLogo(src, hex, white) {
    const c = makeCanvas(src.width, src.height), cx = ctx2d(c);
    cx.drawImage(src, 0, 0);
    const im = cx.getImageData(0, 0, c.width, c.height), d = im.data, rgb = hexToRgb(hex);
    for (let p = 0; p < d.length; p += 4) {
      const a = d[p + 3];
      if (!a) continue;
      const k = white ? 1 : clamp((255 - Math.min(d[p], d[p + 1], d[p + 2]) - 12) / 40, 0, 1);
      d[p] = rgb[0]; d[p + 1] = rgb[1]; d[p + 2] = rgb[2]; d[p + 3] = Math.round(a * k);
    }
    cx.putImageData(im, 0, 0);
    return c;
  }
  // Visuel (sachet) : image aplatie sur fond blanc, reduite pour l'apercu
  function flattenVisual(source, sw, sh, maxLong) {
    const k = Math.min(1, (maxLong || 1800) / Math.max(sw, sh));
    const c = makeCanvas(sw * k, sh * k), cx = ctx2d(c);
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(source, 0, 0, c.width, c.height);
    return c;
  }
  // Visuel construit a partir d'un logo (page d'accueil) : logo centre sur fond blanc au format du sachet,
  // dans 76 % de la largeur et 60 % de la hauteur. Renvoie aussi l'echelle en mm par pixel du logo.
  function logoOnWhite(logo, mm, maxLong) {
    const [Wmm, Hmm] = mm, L = maxLong || 1800;
    const W = Wmm >= Hmm ? L : Math.round(L * Wmm / Hmm), H = Wmm >= Hmm ? Math.round(L * Hmm / Wmm) : L;
    const c = makeCanvas(W, H), cx = ctx2d(c);
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, W, H);
    const k = Math.min(W * 0.76 / logo.width, H * 0.6 / logo.height);
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(logo, (W - logo.width * k) / 2, (H - logo.height * k) / 2, logo.width * k, logo.height * k);
    return { canvas: c, mmPerPx: Wmm / W * k };
  }
  function rotate90(src) {
    const c = makeCanvas(src.height, src.width), cx = ctx2d(c);
    cx.translate(c.width, 0); cx.rotate(Math.PI / 2);
    cx.drawImage(src, 0, 0);
    return c;
  }
  // Miniature (fichier, recapitulatif) au ratio du format d'impression
  function artThumb(src, ratio, bg) {
    const H = 120, W = Math.round(clamp(H * ratio, 60, 240));
    const c = makeCanvas(W, H), cx = ctx2d(c);
    cx.fillStyle = bg || '#fff'; cx.fillRect(0, 0, W, H);
    const pad = bg ? 0.84 : 1, k = Math.min(W * pad / src.width, H * pad / src.height);
    cx.imageSmoothingQuality = 'high';
    cx.drawImage(src, (W - src.width * k) / 2, (H - src.height * k) / 2, src.width * k, src.height * k);
    return c;
  }

  /* ---------------------------------------------------------------- Icones */
  const I = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
    upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15V4M7.5 8.5 12 4l4.5 4.5"/><path d="M4 14.5v3A2.5 2.5 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5-2.5v-3"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9.5 7V4.8h5V7M6.5 7l.8 12.2a1.5 1.5 0 0 0 1.5 1.3h6.4a1.5 1.5 0 0 0 1.5-1.3L17.5 7"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="10" rx="2.5"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5"/></svg>',
    portrait: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><rect x="7" y="3.5" width="10" height="17" rx="2.6"/><circle cx="12" cy="7" r="1.2"/></svg>',
    landscape: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><rect x="3.5" y="7" width="17" height="10" rx="2.6"/><circle cx="7" cy="12" r="1.2"/></svg>',
    grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.6"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.6"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.6"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z"/><path d="M19 15l.8 2.2 2.2.8-2.2.8L19 21l-.8-2.2-2.2-.8 2.2-.8z"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.6v.2"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4 2.8 19.5h18.4L12 4Z"/><path d="M12 10v4.5M12 17.2v.2"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z"/><path d="M4 7.5 12 12l8-4.5M12 12v9"/></svg>',
    cube: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 3 4.5 7v10L12 21l7.5-4V7L12 3Z"/><path d="M4.5 7 12 11l7.5-4M12 11v10"/></svg>',
    top: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="8.5"/><circle cx="12.4" cy="16.2" r="1.7"/></svg>'
  };

  const swatch = (grp, c, i) => `<button type="button" class="c2v-sw${c.hex ? '' : ' c2v-sw--naturel'}" data-grp="${grp}" data-i="${i}" data-tip="${esc(cname(c))}" aria-label="${esc(cname(c))}" aria-pressed="false" style="--sw:${c.hex || NATUREL_REF}"><span class="c2v-sw__dot"></span></button>`;
  const card = (c, i) => `<button type="button" class="c2v-card${c.hex ? '' : ' c2v-sw--naturel'}" data-grp="sil" data-i="${i}" aria-pressed="false" style="--sw:${c.hex || NATUREL_REF}"><span class="c2v-sw__dot"></span><span class="c2v-card__n">${esc(cname(c))}</span><span class="c2v-card__h">${c.hex || T('studio.base_tint', 'Teinte de base')}</span></button>`;
  const cardGrp = (grp, c, i) => `<button type="button" class="c2v-card" data-grp="${grp}" data-i="${i}" aria-pressed="false" style="--sw:${c.hex}"><span class="c2v-sw__dot"></span><span class="c2v-card__n">${esc(cname(c))}</span><span class="c2v-card__h">${esc(c.hex)}</span></button>`;
  const cardPlus = () => `<button type="button" class="c2v-card c2v-sw--plus" data-grp="sil" data-i="custom" aria-pressed="false" aria-expanded="false"><span class="c2v-sw__dot"></span><span class="c2v-sw__plus">${I.plus}</span><span class="c2v-card__n">${T('studio.custom', 'Sur mesure')}</span><span class="c2v-card__h" data-custom-hex>${T('studio.all_tints', 'Toutes les teintes')}</span></button>`;
  const swatchPlus = grp => `<button type="button" class="c2v-sw c2v-sw--plus" data-grp="${grp}" data-i="custom" data-tip="${esc(T('studio.all_colors', 'Toutes les couleurs'))}" aria-label="${esc(T('studio.other_color_aria', 'Choisir une autre couleur'))}" aria-pressed="false" aria-expanded="false"><span class="c2v-sw__dot"></span><span class="c2v-sw__plus">${I.plus}</span></button>`;
  const swatchOrig = grp => `<button type="button" class="c2v-sw c2v-sw--orig" data-grp="${grp}" data-i="orig" data-tip="${esc(cname(ORIG_INK))}" aria-label="${esc(T('studio.orig_aria', "Garder les couleurs d'origine du logo"))}" aria-pressed="true"><span class="c2v-sw__dot"></span></button>`;
  const picker = grp => `
    <div class="c2v-picker" data-picker="${grp}" hidden>
      <div class="c2v-picker__wheel-wrap"><canvas class="c2v-picker__wheel" width="400" height="400" aria-label="${esc(T('studio.wheel_aria', 'Roue chromatique'))}"></canvas><span class="c2v-picker__knob"></span></div>
      <div class="c2v-picker__side">
        <label class="c2v-picker__label">${T('studio.brightness', 'Luminosité')}<input type="range" class="c2v-picker__val c2v-range-mini" min="12" max="100" value="85"></label>
        <label class="c2v-picker__label">${T('studio.hex_code', 'Code hexadécimal')}
          <span class="c2v-picker__hexrow"><span class="c2v-picker__preview"></span><input class="c2v-picker__hex" type="text" maxlength="7" spellcheck="false" autocomplete="off" value="#D6246E"></span>
        </label>
        <p class="c2v-picker__hint">${T('studio.picker_hint', 'Toutes les teintes sont possibles. Le rendu final peut légèrement varier selon le silicone.')}</p>
      </div>
    </div>`;

  const fmtMm = v => NUM.format(Math.round(v * 10) / 10);
  const fmtMmFr = v => NUM_FR.format(Math.round(v * 10) / 10);
  const px300 = v => Math.round(v / 25.4 * 300);
  // sur-titre d'une sous-etape : "Couleur · 1 sur 4"
  const eyebrow = (label, i, n) => T('studio.eyebrow', '{label} · {n} sur {total}', { label: esc(label), n: i, total: n });
  function railHtml(subs) {
    return `<nav class="c2v-rail" data-n="${subs.length}" aria-label="${esc(T('studio.steps_aria', 'Étapes de personnalisation'))}">
              ${subs.map((t, i) => `<button type="button" class="c2v-rail__i${i ? '' : ' is-active'}" data-sub="${i}"><span class="c2v-rail__n"><em>${i + 1}</em>${I.check}</span><span class="c2v-rail__t">${esc(t)}</span></button>`).join('')}
              <span class="c2v-rail__bar"><i></i></span>
            </nav>`;
  }
  function qtySub(cfg, i, n) {
    return `<div class="c2v-sub" data-sub="${i}">
              <p class="c2v-eyebrow">${eyebrow(T('studio.quantity', 'Quantité'), i + 1, n)}</p>
              <h3 class="c2v-title">${T('studio.qty_title', "Combien d'exemplaires ?")}</h3>
              <p class="c2v-lead">${T('studio.qty_lead', 'Personnalisation dès {min} unités, <b>offerte dès {free}</b>.', { min: NUM.format(cfg.minQty), free: NUM.format(cfg.freeFrom) })}</p>
              <div class="c2v-qty">
                <button type="button" class="c2v-qty__b" data-qty="-1" aria-label="${esc(T('studio.less_aria', 'Moins'))}">${I.minus}</button>
                <div class="c2v-qty__val"><output class="c2v-qty__num" data-c2v-qtynum>1 000</output><span>${T('studio.units', 'unités')}</span></div>
                <button type="button" class="c2v-qty__b" data-qty="1" aria-label="${esc(T('studio.more_aria', 'Plus'))}">${I.plus}</button>
              </div>
              <div class="c2v-range">
                <input type="range" class="c2v-range__input" min="0" max="1" step="1" value="0" aria-label="${esc(T('studio.quantity', 'Quantité'))}">
                <div class="c2v-range__ticks"></div>
              </div>
              <div class="c2v-nudge" data-nudge hidden></div>
              <dl class="c2v-bill" data-bill="qty"></dl>
            </div>`;
  }
  function stageCapote() {
    return `<div class="c2v-stage" data-focus="product" data-view="3d">
        <div class="c2v-stage__glow no-empty" aria-hidden="true"></div>
        <div class="c2v-bigqty" aria-hidden="true"><span data-c2v-bigqty>1 000</span><small>${T('studio.units', 'unités')}</small></div>
        <div class="c2v-views" role="group" aria-label="${esc(T('studio.views_aria', 'Vue du produit'))}">
          <button type="button" class="c2v-views__b is-active" data-view="3d">${I.cube}<span>3D</span></button>
          <button type="button" class="c2v-views__b" data-view="top">${I.top}<span>${T('studio.view_top', 'Dessus')}</span></button>
        </div>
        <div class="c2v-scene">
          <div class="c2v-product">
            <div class="c2v-product__float">
              <canvas class="c2v-cv c2v-cv--3d" aria-label="${esc(T('studio.canvas_3d_aria', 'Aperçu 3D de votre capote de verre'))}"></canvas>
              <canvas class="c2v-cv c2v-cv--top" aria-label="${esc(T('studio.canvas_top_aria', 'Vue de dessus de votre capote de verre'))}"></canvas>
            </div>
            <span class="c2v-product__floor" aria-hidden="true"></span>
          </div>
          <figure class="c2v-pack">
            <div class="c2v-pack__card">
              <canvas class="c2v-cv c2v-cv--pack" aria-label="${esc(T('studio.canvas_pack_aria', "Aperçu de l'emballage"))}"></canvas>
              <div class="c2v-pack__empty"><span>${T('studio.your_visual', 'Votre visuel')}</span><small>70 × 90 mm</small></div>
            </div>
            <figcaption class="c2v-pack__cap">${I.box}<span>${T('studio.pack_caption', 'Emballage · 7 × 9 cm')}</span></figcaption>
          </figure>
        </div>
        <div class="c2v-chips">
          <span class="c2v-chip" data-chip="sil"><i class="c2v-chip__dot"></i><span></span></span>
          <span class="c2v-chip" data-chip="ink" hidden><i class="c2v-chip__dot"></i><span></span></span>
          <span class="c2v-chip" data-chip="pack" hidden>${I.check}<span>${T('studio.chip_pack', 'Visuel emballage')}</span></span>
        </div>
        <div class="c2v-loading"><span class="c2v-loading__ring"></span><span>${T('studio.loading', "Préparation de l'aperçu")}</span></div>
      </div>`;
  }
  function paneCapote(cfg) {
    return `<section class="c2v-pane is-active" data-pane="1">
            ${railHtml(SUBS)}

            <div class="c2v-sub is-active" data-sub="0">
              <p class="c2v-eyebrow">${eyebrow(SUBS[0], 1, 4)}</p>
              <h3 class="c2v-title">${T('studio.sil_title', 'La couleur du silicone')}</h3>
              <p class="c2v-lead">${T('studio.sil_lead', "Silicone translucide, finition givrée. Choisissez une teinte : l'aperçu change en direct.")}</p>
              <div class="c2v-swatches c2v-swatches--cards" data-group="sil">${SILICONES.map((c, i) => card(c, i)).join('')}${cardPlus()}</div>
              <p class="c2v-picked" data-picked="sil"></p>
              ${picker('sil')}
            </div>

            <div class="c2v-sub" data-sub="1">
              <p class="c2v-eyebrow">${eyebrow(SUBS[1], 2, 4)}</p>
              <h3 class="c2v-title">${T('studio.logo_title', 'Votre logo sur le silicone')}</h3>
              <p class="c2v-lead">${T('studio.logo_lead', 'Il est imprimé en une seule couleur, centré sur le dessus de la capote.')}</p>
              <label class="c2v-drop" data-drop="logo">
                <input type="file" class="c2v-drop__input" data-file="logo" accept=".png,.jpg,.jpeg,.webp,.svg,.pdf,image/png,image/jpeg,image/webp,image/svg+xml,application/pdf">
                <span class="c2v-drop__icon">${I.upload}</span>
                <span class="c2v-drop__t">${T('studio.drop_logo', 'Glissez votre logo ici ou <u>parcourez vos fichiers</u>')}</span>
                <span class="c2v-drop__s">${T('studio.drop_sub_logo', 'PNG, JPG, SVG ou PDF · 20 Mo max')}</span>
              </label>
              <div class="c2v-file" data-filecard="logo" hidden></div>
              <div class="c2v-notes" data-notes="logo"></div>
              <ul class="c2v-rules">
                <li>${T('studio.rule_logo_ratio', "<b>Format conseillé 1,49:1</b> (zone d'impression 639 × 429 px)")}</li>
                <li>${T('studio.rule_logo_size', '<b>Taille minimale 639 × 429 px</b> ou fichier vectoriel (SVG, PDF)')}</li>
                <li>${T('studio.rule_logo_mono', "<b>Une seule couleur</b> d'impression, fond transparent idéalement")}</li>
              </ul>
              <div class="c2v-block">
                <p class="c2v-label">${T('studio.ink_label', "Couleur d'impression du logo")}</p>
                <div class="c2v-swatches c2v-swatches--sm" data-group="ink">${INKS.map((c, i) => swatch('ink', c, i)).join('')}${swatchPlus('ink')}</div>
                <p class="c2v-picked" data-picked="ink"></p>
                ${picker('ink')}
                <div class="c2v-notes" data-notes="ink"></div>
              </div>
            </div>

            <div class="c2v-sub" data-sub="2">
              <p class="c2v-eyebrow">${eyebrow(SUBS[2], 3, 4)}</p>
              <h3 class="c2v-title">${T('studio.pack_title', 'Le visuel de votre emballage')}</h3>
              <p class="c2v-lead">${T('studio.pack_lead', "Chaque capote est livrée dans son sachet personnalisé. Importez le recto (PDF, PNG, JPG ou SVG), il s'affiche aussitôt sur l'emballage.")}</p>
              <label class="c2v-drop" data-drop="pack">
                <input type="file" class="c2v-drop__input" data-file="pack" accept=".png,.jpg,.jpeg,.webp,.svg,.pdf,image/png,image/jpeg,image/webp,image/svg+xml,application/pdf">
                <span class="c2v-drop__icon">${I.upload}</span>
                <span class="c2v-drop__t">${T('studio.drop_file', 'Glissez votre fichier ici ou <u>parcourez vos fichiers</u>')}</span>
                <span class="c2v-drop__s">${T('studio.drop_sub_logo', 'PNG, JPG, SVG ou PDF · 20 Mo max')}</span>
              </label>
              <div class="c2v-file" data-filecard="pack" hidden></div>
              <div class="c2v-notes" data-notes="pack"></div>
              <ul class="c2v-rules">
                <li>${T('studio.rule_pack_size', '<b>Format 70 × 90 mm</b> en portrait, sinon le visuel est redimensionné sans déformation')}</li>
                <li>${T('studio.rule_pack_res', '<b>Image : {need} minimum</b> (300 dpi) ou fichier vectoriel (PDF, SVG)', { need: `${NUM.format(px300(70))} × ${NUM.format(px300(90))} px` })}</li>
                <li>${T('studio.rule_pack_colors', '<b>Imprimé tel quel</b>, avec les couleurs de votre visuel')}</li>
                <li>${T('studio.rule_pack_bleed', '<b>Sans fonds perdus</b> ni traits de coupe')}</li>
              </ul>
            </div>

            ${qtySub(cfg, 3, 4)}
          </section>`;
  }
  /* Produits a plat : une etape fichier (logo ou visuel couleur) puis la quantite */
  function flatTexts(m) {
    const logo = m.art !== 'visuel', mm = m.mm || [50, 50];
    const fmt = `${fmtMm(mm[0] / 10)} × ${fmtMm(mm[1] / 10)} cm`;
    const orient = Math.abs(mm[0] - mm[1]) < 1 ? T('studio.orient_square', 'carré') : (mm[1] > mm[0] ? T('studio.orient_portrait', 'portrait') : T('studio.orient_landscape', 'paysage'));
    return {
      logo, fmt, orient,
      label: m.artLabel || (logo ? T('studio.logo', 'Logo') : T('studio.visual', 'Visuel')),
      surface: m.surface || T('studio.surface_default', 'le produit'),
      print: m.relief ? T('studio.print_colors_relief', 'Impression en couleurs et en relief') : T('studio.print_colors', 'Impression en couleurs'),
      empty: { title: logo ? T('studio.your_logo', 'Votre logo') : T('studio.your_visual', 'Votre visuel'), sub: `${fmtMm(mm[0])} × ${fmtMm(mm[1])} mm` }
    };
  }
  function stageFlat(cfg, m) {
    const t = flatTexts(m);
    return `<div class="c2v-stage c2v-stage--flat" data-focus="product" data-view="flat">
        <div class="c2v-stage__glow no-empty" aria-hidden="true"></div>
        <div class="c2v-bigqty" aria-hidden="true"><span data-c2v-bigqty>1 000</span><small>${T('studio.units', 'unités')}</small></div>
        ${m.orient ? `<div class="c2v-views" role="group" aria-label="${esc(T('studio.orient_aria', "Orientation de l'impression"))}">
          <button type="button" class="c2v-views__b is-active" data-orient="v" aria-pressed="true">${I.portrait}<span>${T('studio.orient_v', 'Verticale')}</span></button>
          <button type="button" class="c2v-views__b" data-orient="h" aria-pressed="false">${I.landscape}<span>${T('studio.orient_h', 'Horizontale')}</span></button>
        </div>` : ''}
        <div class="c2v-scene">
          <div class="c2v-flat">
            <div class="c2v-flat__float">
              <canvas class="c2v-cv c2v-cv--flat" aria-label="${esc(T('studio.canvas_flat_aria', 'Aperçu de votre {name} personnalisé', { name: m.name || T('studio.product_default', 'produit') }))}"></canvas>
            </div>
          </div>
        </div>
        <div class="c2v-chips">
          ${m.colorStep ? '<span class="c2v-chip" data-chip="plug"><i class="c2v-chip__dot"></i><span></span></span>' : ''}
          <span class="c2v-chip" data-chip="print"><i class="c2v-chip__dot c2v-chip__dot--cmyk"></i><span>${esc(t.print)}</span></span>
          <span class="c2v-chip" data-chip="art" hidden>${I.check}<span>${esc(t.logo ? T('studio.chip_logo', 'Logo importé') : T('studio.chip_visual', 'Visuel importé'))}</span></span>
        </div>
        <div class="c2v-loading"><span class="c2v-loading__ring"></span><span>${T('studio.loading', "Préparation de l'aperçu")}</span></div>
      </div>`;
  }
  function paneFlat(cfg, m) {
    const t = flatTexts(m), mm = m.mm || [50, 50];
    const px = `${NUM.format(px300(mm[0]))} × ${NUM.format(px300(mm[1]))} px`;
    const accept = t.logo
      ? '.png,.jpg,.jpeg,.webp,.svg,.pdf,image/png,image/jpeg,image/webp,image/svg+xml,application/pdf'
      : '.pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg';
    const rules = t.logo
      ? `<li>${T('studio.rule_zone', "<b>Zone d'impression {fmt}</b> ({mm} mm)", { fmt: `<span data-c2v-fmt>${t.fmt}</span>`, mm: `<span data-c2v-mm>${fmtMm(mm[0])} × ${fmtMm(mm[1])}</span>` })}</li>
                <li>${T('studio.rule_print', '<b>{print}</b>, fond transparent idéalement', { print: esc(t.print) })}</li>
                <li>${T('studio.rule_min_size', '<b>Taille minimale {px}</b> (300 dpi) ou fichier vectoriel (SVG, PDF)', { px: `<span data-c2v-px>${px}</span>` })}</li>`
      : `<li>${T('studio.rule_format', '<b>{fmt}</b>, format {orient} ({mm} mm)', { fmt: t.fmt, orient: t.orient, mm: `${fmtMm(mm[0])} × ${fmtMm(mm[1])}` })}</li>
                <li>${T('studio.rule_hd', '<b>PDF, ou PNG / JPG haute définition</b> : {px} minimum (300 dpi)', { px })}</li>
                <li>${T('studio.rule_recto', '<b>Recto seul</b>, sans fonds perdus ni traits de coupe')}</li>`;
    const cs = m.colorStep && m.colorStep.colors && m.colorStep.colors.length ? m.colorStep : null;
    const n = cs ? 3 : 2, ai = cs ? 1 : 0;
    const colorSub = cs ? `<div class="c2v-sub is-active" data-sub="0">
              <p class="c2v-eyebrow">${eyebrow(cs.label || T('studio.color', 'Couleur'), 1, n)}</p>
              <h3 class="c2v-title">${esc(cs.title || T('studio.color_title_default', 'La couleur'))}</h3>
              <p class="c2v-lead">${esc(cs.lead || '')}</p>
              <div class="c2v-swatches c2v-swatches--cards" data-group="plug">${cs.colors.map((c, i) => cardGrp('plug', c, i)).join('')}</div>
              <p class="c2v-picked" data-picked="plug"></p>
            </div>

            ` : '';
    return `<section class="c2v-pane is-active" data-pane="1">
            ${railHtml(cs ? [cs.label || T('studio.color', 'Couleur'), t.label, T('studio.quantity', 'Quantité')] : [t.label, T('studio.quantity', 'Quantité')])}

            ${colorSub}<div class="c2v-sub${cs ? '' : ' is-active'}" data-sub="${ai}">
              <p class="c2v-eyebrow">${eyebrow(t.label, ai + 1, n)}</p>
              <h3 class="c2v-title">${t.logo ? T('studio.art_title_logo', 'Votre logo sur {surface}', { surface: esc(t.surface) }) : T('studio.art_title_visual', 'Votre visuel sur {surface}', { surface: esc(t.surface) })}</h3>
              <p class="c2v-lead">${esc(m.lead || '')}</p>
              <label class="c2v-drop" data-drop="art">
                <input type="file" class="c2v-drop__input" data-file="art" accept="${accept}">
                <span class="c2v-drop__icon">${I.upload}</span>
                <span class="c2v-drop__t">${t.logo ? T('studio.drop_logo', 'Glissez votre logo ici ou <u>parcourez vos fichiers</u>') : T('studio.drop_file', 'Glissez votre fichier ici ou <u>parcourez vos fichiers</u>')}</span>
                <span class="c2v-drop__s">${t.logo ? T('studio.drop_sub_logo', 'PNG, JPG, SVG ou PDF · 20 Mo max') : T('studio.drop_sub_visual', 'PDF, PNG ou JPG · 20 Mo max')}</span>
              </label>
              <div class="c2v-file" data-filecard="art" hidden></div>
              <div class="c2v-notes" data-notes="art"></div>
              <ul class="c2v-rules">
                ${rules}
              </ul>
              ${t.logo ? `<div class="c2v-block">
                <p class="c2v-label">${T('studio.ink_label', "Couleur d'impression du logo")}</p>
                <div class="c2v-swatches c2v-swatches--sm" data-group="ink">${swatchOrig('ink')}${INKS.map((c, i) => swatch('ink', c, i)).join('')}${swatchPlus('ink')}</div>
                <p class="c2v-picked" data-picked="ink"></p>
                ${picker('ink')}
                <div class="c2v-notes" data-notes="ink"></div>
              </div>` : ''}
            </div>

            ${qtySub(cfg, ai + 1, n)}
          </section>`;
  }

  /* Textes du modele (metachamp studio.modele du produit miroir) traduits par les cles
     c2v.model.<cle>.<champ> ; le JSON du metachamp reste la source francaise de repli.
     Cle du modele : champ "key" s'il existe, "capote" pour la capote, sinon nom du visuel
     sans "c2v-studio-" ni extension (c2v-studio-cyd.webp -> cyd). Meme regle en Liquid (accueil). */
  const slug = s => String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  function modelKey(m) {
    if (!m) return 'capote';
    if (m.key) return slug(m.key);
    if (m.kind !== 'flat') return 'capote';
    const img = String(m.image || '').split('/').pop().split('?')[0].replace(/^c2v-studio-/i, '').split('.')[0];
    return slug(img || m.name || '');
  }
  // copie du modele aux textes traduits ; m.fr = modele d'origine (francais), couleurs : name = francais, label = traduit
  function localModel(m) {
    if (!m || typeof m !== 'object') return m;
    const k = 'model.' + modelKey(m) + '.';
    const tr = (f, v) => (typeof v === 'string' && v ? T(k + f, v) : v);
    const out = Object.assign({}, m, { name: tr('name', m.name), unit: tr('unit', m.unit), artLabel: tr('art_label', m.artLabel), lead: tr('lead', m.lead), surface: tr('surface', m.surface), fr: m });
    const cs = m.colorStep;
    if (cs && typeof cs === 'object') {
      out.colorStep = Object.assign({}, cs, {
        label: tr('color_step_label', cs.label), title: tr('color_step_title', cs.title), lead: tr('color_step_lead', cs.lead),
        prop: tr('color_step_prop', cs.prop), recap: tr('color_step_recap', cs.recap), chip: tr('color_step_chip', cs.chip),
        colors: Array.isArray(cs.colors) ? cs.colors.map(c => Object.assign({}, c, { label: tr('color_' + slug(c.name || ''), c.name) })) : cs.colors
      });
    }
    return out;
  }

  function template(cfg) {
    const priv = esc(cfg.privacy), terms = esc(cfg.terms);
    const m = cfg.model || { kind: 'capote' }, flat = m.kind === 'flat';
    const joined = flat ? T('studio.joined_flat', "Votre fichier et l'aperçu sont joints à la commande.") : T('studio.joined_capote', "Votre logo, votre visuel d'emballage et l'aperçu sont joints à la commande.");
    const consent = T('studio.consent', "En cochant cette case, <b>je valide mon aperçu</b>, j'accepte les {terms} et la {privacy}, et j'accepte que Capote2Verre me recontacte au sujet de mon projet.", {
      terms: `<a href="${terms}" target="_blank" rel="noopener">${T('studio.consent_terms', 'conditions générales de vente')}</a>`,
      privacy: `<a href="${priv}" target="_blank" rel="noopener">${T('studio.consent_privacy', 'politique de confidentialité')}</a>`
    });
    return `
<div class="c2v" role="dialog" aria-modal="true" aria-labelledby="c2v-title${esc(cfg.uid || '')}" hidden>
  <div class="c2v__backdrop no-empty" data-c2v-close></div>
  <div class="c2v__box">
    <header class="c2v-head">
      <div class="c2v-brand">
        <span class="c2v-brand__mark" aria-hidden="true"></span>
        <div class="c2v-brand__txt">
          <p class="c2v-brand__title" id="c2v-title${esc(cfg.uid || '')}">${T('studio.title', 'Studio de personnalisation')}</p>
          <p class="c2v-brand__sub"><span class="c2v-live"></span>${T('studio.live', 'Aperçu en direct')}</p>
        </div>
      </div>
      <ol class="c2v-steps">
        <li><button type="button" class="c2v-steps__i is-active" data-step="1"><span class="c2v-steps__n">1</span><span class="c2v-steps__t">${T('studio.step_custom', 'Personnalisation')}</span></button></li>
        <li class="c2v-steps__sep" aria-hidden="true"></li>
        <li><button type="button" class="c2v-steps__i" data-step="2"><span class="c2v-steps__n">2</span><span class="c2v-steps__t">${T('studio.step_contact', 'Coordonnées')}</span></button></li>
        <li class="c2v-steps__sep" aria-hidden="true"></li>
        <li><button type="button" class="c2v-steps__i" data-step="3"><span class="c2v-steps__n">3</span><span class="c2v-steps__t">${T('studio.step_payment', 'Paiement')}</span></button></li>
      </ol>
      <div class="c2v-head__end">
        ${cfg.home ? `<button type="button" class="c2v-switch" data-c2v-switch aria-label="${esc(T('studio.switch', 'Changer de produit'))}">${I.grid}<span>${T('studio.switch', 'Changer de produit')}</span></button>` : ''}
        <button type="button" class="c2v-close" data-c2v-close aria-label="${esc(T('studio.close_aria', 'Fermer le studio'))}">${I.close}</button>
      </div>
    </header>

    <div class="c2v-body">
      ${flat ? stageFlat(cfg, m) : stageCapote()}
      <div class="c2v-panel">
        <div class="c2v-scroll">
          ${flat ? paneFlat(cfg, m) : paneCapote(cfg)}
          <section class="c2v-pane" data-pane="2">
            <p class="c2v-eyebrow">${T('studio.step_of', 'Étape {n} sur {total}', { n: 2, total: 3 })}</p>
            <h3 class="c2v-title">${dm(T('studio.contact_title', 'Vos coordonnées'))}</h3>
            <p class="c2v-lead">${T('studio.contact_lead', 'Pour préparer votre commande et vous recontacter si besoin. La livraison et la facturation se remplissent ensuite au paiement.')}</p>
            <div class="c2v-fields">
              <label class="c2v-field c2v-field--full">
                <span class="c2v-field__l">${T('studio.field_company', "Nom de l'entreprise")} <span class="c2v-field__opt">${T('studio.optional', '(facultatif)')}</span></span>
                <input type="text" class="c2v-input" data-c2v-f="company" autocomplete="organization" maxlength="120" placeholder="${esc(T('studio.ph_company', 'Entreprise, association, collectivité…'))}">
              </label>
              <label class="c2v-field">
                <span class="c2v-field__l">${T('studio.field_first', 'Prénom')}</span>
                <input type="text" class="c2v-input" data-c2v-f="first" autocomplete="given-name" maxlength="60" placeholder="${esc(T('studio.ph_first', 'Camille'))}">
                <span class="c2v-field__err" data-c2v-ferr="first" hidden>${T('studio.err_first', 'Indiquez votre prénom.')}</span>
              </label>
              <label class="c2v-field">
                <span class="c2v-field__l">${T('studio.field_last', 'Nom')}</span>
                <input type="text" class="c2v-input" data-c2v-f="last" autocomplete="family-name" maxlength="60" placeholder="${esc(T('studio.ph_last', 'Martin'))}">
                <span class="c2v-field__err" data-c2v-ferr="last" hidden>${T('studio.err_last', 'Indiquez votre nom.')}</span>
              </label>
              <label class="c2v-field c2v-field--full">
                <span class="c2v-field__l">${T('studio.field_phone', 'Téléphone')}</span>
                <input type="tel" class="c2v-input" data-c2v-f="phone" autocomplete="tel" inputmode="tel" maxlength="25" placeholder="${esc(T('studio.ph_phone', '06 12 34 56 78'))}">
                <span class="c2v-field__err" data-c2v-ferr="phone" hidden>${T('studio.err_phone', 'Ce numéro de téléphone ne semble pas valide.')}</span>
              </label>
              <label class="c2v-field c2v-field--full">
                <span class="c2v-field__l">${T('studio.field_email', 'Adresse email')}</span>
                <input type="email" class="c2v-input" data-c2v-f="email" data-c2v-email autocomplete="email" inputmode="email" maxlength="254" placeholder="${esc(T('studio.ph_email', 'vous@entreprise.fr'))}">
                <span class="c2v-field__err" data-c2v-ferr="email" data-c2v-emailerr hidden>${T('studio.err_email', 'Cette adresse email ne semble pas valide.')}</span>
              </label>
            </div>
            <label class="c2v-check c2v-check--approve"><input type="checkbox" data-c2v-approve><span>${consent}</span></label>
            <p class="c2v-legal">${T('studio.withdrawal', "Produit personnalisé selon vos spécifications : le droit de rétractation de 14 jours ne s'applique pas (article L221-28, 3° du Code de la consommation).")}</p>
          </section>

          <section class="c2v-pane" data-pane="3">
            <p class="c2v-eyebrow">${T('studio.step_of', 'Étape {n} sur {total}', { n: 3, total: 3 })}</p>
            <h3 class="c2v-title">${dm(T('studio.recap_title', 'Récapitulatif'))}</h3>
            <ul class="c2v-recap" data-recap></ul>
            <dl class="c2v-bill c2v-bill--final" data-bill="final"></dl>
            <div class="c2v-cart" data-c2v-cart hidden></div>
            <div class="c2v-more" data-c2v-more>
              <button type="button" class="c2v-more__btn" data-c2v-another aria-expanded="false">${I.plus}<span>${T('studio.another', 'Ajouter un autre produit personnalisé')}</span></button>
              ${cfg.home ? '' : `<div class="c2v-more__choice" data-c2v-choice hidden>
                <button type="button" class="c2v-more__opt" data-c2v-another-same><b>${T('studio.another_same', 'Le même produit')}</b><small>${T('studio.another_same_sub', 'Avec un autre logo, une autre couleur ou une autre quantité')}</small></button>
                <a class="c2v-more__opt" href="${esc(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + '#personnaliser')}" data-c2v-another-other><b>${T('studio.another_other', 'Un autre produit')}</b><small>${T('studio.another_other_sub', "Capote de verre, bouchons d'oreille, sifflet, éthylotest, test CYD")}</small></a>
              </div>`}
              <p class="c2v-more__note">${T('studio.another_note', 'Cette personnalisation reste dans votre panier et vos coordonnées sont gardées.')}</p>
            </div>
            <div class="c2v-testnote" data-testnote>${I.lock}<span>${T('studio.secure_note', '<b>Paiement sécurisé.</b> Vous allez être redirigé vers le paiement Shopify, les frais de livraison y sont calculés. {joined}', { joined })}</span></div>
          </section>
        </div>

        <footer class="c2v-foot">
          <div class="c2v-total">
            <div class="c2v-total__main">
              <span class="c2v-total__l">${T('studio.foot_units', '{qty} unités personnalisées', { qty: '<b data-c2v-fq>1 000</b>' })}</span>
              <span class="c2v-total__ht"><strong data-c2v-ht>0,00 €</strong><em>${T('common.ht', 'HT')}</em></span>
            </div>
            <div class="c2v-total__side">
              <span class="c2v-total__ttc" data-c2v-ttc></span>
              <span class="c2v-total__unit" data-c2v-unit></span>
            </div>
          </div>
          <div class="c2v-actions">
            <button type="button" class="c2v-btn c2v-btn--ghost" data-c2v-prev aria-label="${esc(T('studio.prev_aria', 'Étape précédente'))}">${I.back}</button>
            <button type="button" class="c2v-btn c2v-btn--primary" data-c2v-next><span>${T('studio.btn_continue', 'Continuer')}</span>${I.arrow}</button>
          </div>
        </footer>
      </div>
    </div>
    <div class="c2v-toast no-empty" role="status" aria-live="polite"></div>
  </div>
</div>`;
  }

  window.C2VLib = {
    SILICONES, INKS, NATUREL_REF, ZONE_W, ZONE_H, ZONE_RATIO, MAX_FILE, $, $$, clamp, NUM, money, esc, reduceMotion, hexToRgb, rgbToHex, isHex, relLum, contrast, hsvToRgb, rgbToHsv, makeCanvas, ctx2d, loadStudioImage, renderPdf, Lid3D, TopView, Pack, fileKind, svgSource, rasterSource, analyzeLogo, buildZone, I, template, flatTexts, px300, fmtMm, flatBox, FlatView, colorLogo, monoLogo, ORIG_INK, flattenVisual, logoOnWhite, rotate90, artThumb,
    T, TP, TFr, LOCALE, FR, DEC, NUM_FR, moneyFr, fmtMmFr, cname, modelKey, localModel
  };
})();
